import { render, staticRenderFns } from "./c-modal.vue?vue&type=template&id=5d3ca0d2"
import script from "./c-modal.vue?vue&type=script&lang=js"
export * from "./c-modal.vue?vue&type=script&lang=js"
import style0 from "./c-modal.vue?vue&type=style&index=0&id=5d3ca0d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports